import ShowByRole from 'App/components/ShowByRole';
import { useGetPlanDebt } from 'domains/Auth/hooks';
import { PaymentStatusAlert } from 'domains/Billing/Checkout/components';
import { KycRejectedAlert } from 'domains/NuvemPagoCommons/components/KycRejectedAlert';
import AlertFirstSale from '../AlertFirstSale';
import DomainDisconnectedAlert from '../DomainDisconnectedAlert';
import FacebookConnectionStatusAlert from '../FacebookConnectionStatusAlert';
import NuvemEnvioAdminBlockingAlert from '../NuvemEnvioAdminBlockingAlert';
import TrialMessages from '../TrialMessages';
import UpdateSuggestion from '../UpdateSuggestion';
import VulnerablePasswordAlert from '../VulnerablePasswordAlert';

function NewAlertNotifications() {
  const { shouldUseDebtData } = useGetPlanDebt(false);
  return (
    <>
      <VulnerablePasswordAlert />
      <DomainDisconnectedAlert />
      <ShowByRole includeRoles="full">
        <>
          <KycRejectedAlert />
          <NuvemEnvioAdminBlockingAlert />
          <TrialMessages />
          <FacebookConnectionStatusAlert />
          <UpdateSuggestion />
        </>
      </ShowByRole>
      <ShowByRole includeRoles="orders">
        <AlertFirstSale />
      </ShowByRole>
      <ShowByRole includeRoles="full">
        {!shouldUseDebtData && (
          <PaymentStatusAlert concept="plan-cost" isExternalContext />
        )}
      </ShowByRole>
    </>
  );
}

export default NewAlertNotifications;
